<template>
  <!-- <div
    :style="{width: '74px'}"
    class="shrikMenu"
    v-bar="{preventParentScroll: true, scrollThrottle: 30}"
  >-->
  <GeminiScrollbar :autoshow="true" :style="{width: '74px'}" class="shrikMenu">
    <Menu :autoshow="true" :style="{width: '74px', padding: '0'}" ref="sideMenu">
      <MenuGroup title="系统功能" v-if="menuLayoutType != 'LEFT_TOP' && menus.system_menu">
        <template v-for="(item, index) in menus['system_menu']">
          <template v-if="item.children != undefined && item.children.length > 0">
            <Dropdown
              :key="item.name+'-'+index"
              :transfer-class-name="'selfMenu'"
              @on-click="(name) => changeSubMenu(name, item)"
              placement="right-start"
              transfer
              trigger="hover"
            >
              <MenuItem :key="item.pathName" :name="item.pathName">
                <i :class="item.menuIcon || 'fa fa-image'"></i>
              </MenuItem>
              <DropdownMenu
                :style="{width: 'auto !important'}"
                :transfer-class-name="'selfMenu'"
                slot="list"
              >
                <template v-for="(child, idx) in item.children">
                  <DropdownItem
                    :key="child.pathName+'-'+idx"
                    :name="child.pathName"
                    v-if="child.children == undefined || child.children == null || child.children.length == 0"
                  >
                    <span style="padding-left:10px;">{{ child.menuName }}</span>
                    <Badge :count="$store.getters.inboxCount" v-if="child.menuCode == 'inbox'"></Badge>
                    <Badge
                      :count="$store.getters.todoCount"
                      v-if="child.menuCode == 'workflow.config.myaffairs.todo'"
                    ></Badge>
                  </DropdownItem>
                  <sub-side-menu-shrink
                    :item="child"
                    :key="'sub-menu-'+child.pathName+'-index'"
                    v-else
                  ></sub-side-menu-shrink>
                </template>
              </DropdownMenu>
            </Dropdown>
          </template>
          <template v-else>
            <Dropdown
              :key="item.pathName"
              :transfer-class-name="'selfMenu'"
              @on-click="(name) => changeSubMenu(name, item)"
              placement="right-start"
              transfer
              trigger="hover"
            >
              <MenuItem :name="item.pathName">
                <i :class="item.menuIcon || 'fa fa-image'" :size="20"></i>
              </MenuItem>
              <DropdownMenu :style="{width: 'auto !important'}" slot="list">
                <template>
                  <DropdownItem
                    :class="item.pathName == activeName ? 'active' : ''"
                    :key="item.pathName"
                    :name="item.pathName"
                  >
                    <span style="padding-left:10px;">{{ item.menuName }}</span>
                    <Badge :count="$store.getters.inboxCount" v-if="item.menuCode == 'inbox'"></Badge>
                    <Badge
                      :count="$store.getters.todoCount"
                      v-if="item.menuCode == 'workflow.config.myaffairs.todo'"
                    ></Badge>
                  </DropdownItem>
                </template>
              </DropdownMenu>
            </Dropdown>
          </template>
        </template>
      </MenuGroup>
      <MenuGroup title="系统管理" v-if="menus['config_menu']">
        <template v-for="(item, index) in menus['config_menu']">
          <template v-if="item.children != undefined && item.children.length > 0">
            <Dropdown
              :key="item.name+'-'+index"
              :transfer-class-name="'selfMenu'"
              @on-click="(name) => changeSubMenu(name, item)"
              placement="right-start"
              transfer
              trigger="hover"
            >
              <MenuItem :key="item.pathName" :name="item.pathName">
                <i :class="item.menuIcon || 'fa fa-image'"></i>
              </MenuItem>
              <DropdownMenu
                :style="{width: 'auto !important'}"
                :transfer-class-name="'selfMenu'"
                slot="list"
              >
                <template v-for="(child, idx) in item.children">
                  <DropdownItem
                    :key="child.pathName+'-'+idx"
                    :name="child.pathName"
                    v-if="child.children == undefined || child.children == null || child.children.length == 0"
                  >
                    <span style="padding-left:10px;">{{ child.menuName }}</span>
                  </DropdownItem>
                  <sub-side-menu-shrink
                    :item="child"
                    :key="'sub-menu-'+child.pathName+'-index'"
                    v-else
                  ></sub-side-menu-shrink>
                </template>
              </DropdownMenu>
            </Dropdown>
          </template>
          <template v-else>
            <Dropdown
              :key="item.pathName"
              :transfer-class-name="'selfMenu'"
              @on-click="(name) => changeSubMenu(name, item)"
              placement="right-start"
              transfer
              trigger="hover"
            >
              <MenuItem :name="item.pathName">
                <i :class="item.menuIcon || 'fa fa-image'" :size="20"></i>
              </MenuItem>
              <DropdownMenu :style="{width: 'auto !important'}" slot="list">
                <template>
                  <DropdownItem
                    :class="item.pathName == activeName ? 'active' : ''"
                    :key="item.pathName"
                    :name="item.pathName"
                  >
                    <span style="padding-left:10px;">{{ item.menuName }}</span>
                  </DropdownItem>
                </template>
              </DropdownMenu>
            </Dropdown>
          </template>
        </template>
      </MenuGroup>
    </Menu>
  </GeminiScrollbar>
  <!-- </div> -->
</template>

<script>
import subSideMenuShrink from './subSideMenuShrink.vue'
export default {
  name: 'sidebarMenuShrink',
  components: {
    subSideMenuShrink
  },
  props: {
    menus: {
      type: Object,
      default: {}
    },
    activeName: {
      type: String
    }
  },
  data () {
    return {
      opens: this.$store.getters['menuInfo/openNames'] || []
    }
  },
  computed: {
    menuLayoutType: function () {
      // return 'TOP'
      return this.$store.getters['systemInfo/menuLayout'] || 'LEFT'
    },
    isBack: function () {
      return this.$store.getters['menuInfo/isBack']
    },
  },
  methods: {
    changeSubMenu (active, parent) {
      this.$emit('on-change', active)
      this.$store.dispatch("menuInfo/updateMenuInfoParams", { key: 'openNames', value: [parent.pathName] })

    },
    itemTitle (item) {
      if (typeof item.menuName === 'object') {
        return this.$t(item.meta.title.i18n)
      } else {
        return item.menuName
      }
    }
  }
};
</script>
<style>
.selfMenu .ivu-dropdown {
  display: block !important;
}
</style>